var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block rounded-full",class:_vm.clazz},[_c('div',{staticClass:"avatar admiral",class:['avatar-' + _vm.avatarSize, 'avatar-img']})])}
var staticRenderFns = []

export { render, staticRenderFns }